import { render, staticRenderFns } from "./GestionEvaluacionVulnerabilidades.vue?vue&type=template&id=a732df96&"
import script from "./GestionEvaluacionVulnerabilidades.vue?vue&type=script&lang=js&"
export * from "./GestionEvaluacionVulnerabilidades.vue?vue&type=script&lang=js&"
import style0 from "./GestionEvaluacionVulnerabilidades.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports